import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/app/shared/constants';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private http: HttpClient) { }
  Baseurl(): string {
    return Constants.BASE_URL;
  }

  getCustomerListBySearch(inputData) {
    return this.http.post<any>(this.Baseurl() + Constants.GET_CUSTOMERS_BY_SEARCH, inputData, {observe: 'response'});
  }
  getCustomerById(inputData: { SearchID: number; LocationID: number }) {
    return this.http.post<any>(this.Baseurl() + Constants.GET_CUSTOMER_BY_ID, inputData);
  }

  getFinancers(locationId) {
    return this.http.get(this.Baseurl() + Constants.ACCOUNTS_MASTERS_GETFINANCERS+locationId);
  }

  postOtpQuotation(inputData: { LocationID: number; QuotationSlNo: number | string; CreateUserID: string }) {
    return this.http.post<any>(this.Baseurl() + Constants.OTP_QUOTATION, inputData, { observe: 'response' });
  }

  /**
   * Sends OTP for quotation approval. Payload can include OTP for verification.
   * @param payload { LocationID: number; QuotationSlNo: number | string; CreateUserID: string; OTP?: string }
   */
  sendQuotationOTP(payload: { LocationID: number; QuotationSlNo: number | string; CreateUserID: string; OTP?: string }): Observable<any> {
    return this.http.post<any>(this.Baseurl() + Constants.OTP_QUOTATION, payload, { observe: 'response' });
  }

  /**
   * Verifies OTP for quotation approval.
   * @param payload { QuotationSlNo: number; LocationID: number; CreateUserID: string; OTP: number }
   */
  verifyQuotationOTP(payload: { QuotationSlNo: number; LocationID: number; CreateUserID: string; OTP: number }): Observable<any> {
    return this.http.post<any>(this.Baseurl() + Constants.VERIFY_OTP_QUOTATION, payload, { observe: 'response' });
  }
}
